import Graphic from "@arcgis/core/Graphic";
import decodeUrl from "../../../utility-tools/decodeUrl";
//import { OCLandInsightsID } from "../../../customParameterLayers";

export const AddGraphicsFromURL=(view,parcels)=>{


       if (decodeUrl()?.['asrComps']?.length>0){
        const apnlist = decodeUrl()?.['asrComps']
        view.graphics.removeAll();
        var labelApndict = {}
        var labelslist = [];
        var labelsSorted = [];
        var featuresSorted = [];
        var id2apn = {}
        var apn2id = {}
        var uniqueapns = []
        // if(!layer){
        //     return
        //   }
          
          let legallotsLayer=view.map.allLayers.find((layer)=>{
            return layer?.customParameters?.OCLandInsightsID === parcels
          })
          console.log('legallotsLayer',legallotsLayer)
          var whereClause = "";
            
          let symbolblue = {
              type: "simple-fill",  // autocasts as new SimpleFillSymbol()
              color: [ 51,51, 204, 0.9 ],
              style: "none",
              outline: {  // autocasts as new SimpleLineSymbol()
                color: "blue",
                width: 1.5
              }
          };
          
          let symbolred = {
              type: "simple-fill",  // autocasts as new SimpleFillSymbol()
              color: [ 51,51, 204, 0.9 ],
              style: "none",
              outline: {  // autocasts as new SimpleLineSymbol()
                color: "red",
                width: 1.5
              }
          };
          
          let symbolgreen = {
              type: "simple-fill",  // autocasts as new SimpleFillSymbol()
              color: [ 51,51, 204, 0.9 ],
              style: "none",
              outline: {  // autocasts as new SimpleLineSymbol()
                color: "green",
                width: 1.5
              }
          };
          
          let symbolcolors = {
            1:"blue",
            2:"red",
            3:"green"
          }
          
          let symbollist = {
            1:symbolblue,
            2:symbolred,
            3:symbolgreen
          }
        // const queryString = window.location.search;
        // if(queryString.substring(1)){
            let apnsformattedlist = [];
            let typelist = [];
            let labellist = [];
            let apnsformatted = '';
            let featuredict = {}
            let typedict = {};
            let labeldict = {};
            // const search = queryString.substring(1);
            // let myobject = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
            // let apnlistvalue = myobject.apnlist
            // console.log(JSON.parse(apnlistvalue))
            //let apnlist = JSON.parse(apnlistvalue)
            // if (apnlist){
             apnlist.forEach(function(x, index){
              if (!uniqueapns.includes(x.APN.toString())){
                let apnfound = false;
                uniqueapns.push(x.APN.toString())
                var apnformat = '';
              
                console.log(x.APN.toString().substring(0, 3))
                var firstthree = Number(x.APN.toString().substring(0, 3))
               
                if (((firstthree >= 1) && (firstthree <= 816)) || (firstthree == 894) || ((firstthree >= 890) && (firstthree <= 892))){
                   var secondthree = x.APN.toString().substr(3, 3)
                   var three = x.APN.toString().substr(6, 2)
                   apnformat = firstthree.toString().padStart(3,'0')+"-"+secondthree+"-"+three
                   apnfound = true
                  console.log(x.APN, apnformat) 
                }
                 if (((firstthree >= 898) && (firstthree <= 899)) || (firstthree == 895) || (firstthree == 897) ||((firstthree >= 930) && (firstthree <= 939))){
                    var secondthree = x.APN.toString().substr(3, 2)
                    var two = x.APN.toString().substr(5, 3)
                     apnformat = firstthree.toString().padStart(3,'0')+"-"+secondthree+"-"+two;
                     apnfound = true
                  console.log(x.APN,apnformat) 
                }

                if (apnfound === true){
                  typelist.push(x.Type);
                  labellist.push(x.Label)
                  typedict[apnformat] = x.Type;
                  labeldict[apnformat] = x.Label;
                  
                  // featuredict[apnformat] = {
                  //   type: typelist[index],
                  //   label: labellist[index]
                  // }
  
                  featuredict[apnformat] = {
                    type: typedict[apnformat],
                    label: labeldict[apnformat]
                  }
               //   apnsformattedlist.push("'"+apnformat+"'")
  //////////////////////
                  // id2apn[Number(labellist[index])] = apnformat
                  // apn2id[apnformat] = Number(labellist[index])
                  // apnsformattedlist.push("'"+apnformat+"'")
                  // // SORTING FEATURES
                  // labelApndict[labellist[index]] = apnformat
                  // labelslist.push(Number(labellist[index]))
  //////////////////////////
                  id2apn[Number(labeldict[apnformat])] = apnformat
                  apn2id[apnformat] = Number(labeldict[apnformat])
                  apnsformattedlist.push("'"+apnformat+"'")
                  // SORTING FEATURES
                  labelApndict[labeldict[apnformat]] = apnformat
                  labelslist.push(Number(labeldict[apnformat]))
                } else {
                  console.log('APN NOT FOUND in Landbase!',x.APN.toString(),x)
                }



              } else {
                console.log('skipped',x.APN.toString(),x)
              }
              })
              
              labelsSorted = labelslist.sort(function(a, b) {
                return a - b;
              });

              if (apnsformattedlist.length > 0){
                let apns_formatted = "("+apnsformattedlist.toString()+")"
                whereClause = "AssessmentNo IN " + apns_formatted;
                console.log('whereClause',whereClause)
                console.log('featuredict',featuredict)
                const apnQuery = {
                where: whereClause, // Set by select element
                outFields: ["*"], // Attributes to return
                returnGeometry: true
              };
  
              legallotsLayer.queryFeatures(apnQuery)
              .then((results) => {
                  let geometries=[]
                  let selectFeatures=[]
            //      console.log('Features',results.features.length)
                  if (results.features.length > 0){
                    labelsSorted.forEach(function(label){
                    //    console.log('label',label)
                        results.features.forEach(function(feature){
                            let apnno = feature.attributes.AssessmentNo;
                            if (id2apn[label] === apnno){
                                featuresSorted.push(feature)
                            }
  
                        })
                    })
                    
                  featuresSorted.forEach(function(feature){
                    selectFeatures.push(feature)
                  let apnno = feature.attributes.AssessmentNo;
                  geometries.push(feature.geometry)
                  let centroid = feature.geometry.centroid;
                  let polyGraphic = new Graphic({
                      geometry: feature.geometry,
                      symbol: symbollist[featuredict[apnno].type]
                  });
                      let labelSymbol = {
                      type: "text",  // autocasts as new TextSymbol()
                      color: symbolcolors[featuredict[apnno].type],
                      haloColor: "white",
                      haloSize: "1px",
                      text: featuredict[apnno].label,
                      xoffset: 0,
                      yoffset: 0,
                      font: {  // autocasts as new Font()
                          size: 12,
                          family: "Josefin Slab",
                          weight: "bold"
                      }
                      };
                      let labelGraphic = new Graphic({
                          geometry: centroid,
                          symbol: labelSymbol
                      });
                      // layer.add(polyGraphic);
                      // layer.add(labelGraphic);
                      view.graphics.add(labelGraphic);
                      view.graphics.add(polyGraphic);              
                  })
                  view.goTo(geometries)
                  view.popup.features=selectFeatures
                 
                }
              })
              .catch((error) => {
                  console.log(error.error);
              });
              }else 
              {

              }
        // }
     }else{

     }
    };
    
